import { useBrandId } from 'AppProvider';
import useIsHyattLMSEnabledFlag from './useIsHyattLMSEnabledFlag';
import useValidateHyattEligibility from './useValidateHyattEligibility';

const useHyattCartValidation = (listingIds: string[]) => {
  const isHyattLMSEnabled = useIsHyattLMSEnabledFlag();
  const brandId = useBrandId();
  const { isEligible, isLoading, areAnyEligible } = useValidateHyattEligibility(
    brandId,
    isHyattLMSEnabled,
    listingIds,
  );

  return { isEligible, isLoading, areAnyEligible };
};

export default useHyattCartValidation;
